export type VisibleSelectionState = {
  allSelected: boolean;
  indeterminate: boolean;
};

export function getVisibleSelectionState(
  visibleKeys: readonly string[],
  selectedKeys: readonly string[],
): VisibleSelectionState {
  const selected = new Set(selectedKeys);
  const selectedCount = visibleKeys.reduce((count, key) => count + Number(selected.has(key)), 0);
  const allSelected = visibleKeys.length > 0 && selectedCount === visibleKeys.length;

  return {
    allSelected,
    indeterminate: selectedCount > 0 && !allSelected,
  };
}

export function toggleVisibleSelection(
  selectedKeys: readonly string[],
  visibleKeys: readonly string[],
  selectVisible: boolean,
): string[] {
  const visible = new Set(visibleKeys);
  if (!selectVisible) return selectedKeys.filter((key) => !visible.has(key));
  return Array.from(new Set([...selectedKeys, ...visible]));
}
